import { createFileRoute } from "@tanstack/react-router";
import PricingDashboardV4 from "../../../../../../views/_pricing/DashboardV4";

export const Route = createFileRoute("/_authenticated/user/pricing/dashboard/category/$category")({
  component: PricingDashboardV4,
});
